import type { SaveTranslationsBody, TranslationsView } from "@/api/researchCms.service";
import type { TranslationsFormValues } from "../schemas/orgViewSchemas";

export const EMPTY_TRANSLATIONS_FORM: TranslationsFormValues = {
  commentary: { postContent: "", clerksCommentary: "" },
  matters: {},
};

export function toTranslationsFormValues(view: TranslationsView | null): TranslationsFormValues {
  if (!view) return EMPTY_TRANSLATIONS_FORM;
  const matters: Record<string, string> = {};
  for (const matter of view.matters) {
    matters[matter.matterId] = matter.translation?.summary ?? "";
  }
  return {
    commentary: {
      postContent: view.commentary.translation?.postContent ?? "",
      clerksCommentary: view.commentary.translation?.clerksCommentary ?? "",
    },
    matters,
  };
}

export type DirtyTranslations = {
  commentary?: { postContent?: boolean; clerksCommentary?: boolean };
  matters?: Record<string, boolean | undefined>;
};

export function translationsSaveBody(
  values: TranslationsFormValues,
  dirty: DirtyTranslations,
): SaveTranslationsBody | null {
  const body: SaveTranslationsBody = {};
  if (dirty.commentary?.postContent || dirty.commentary?.clerksCommentary) {
    const clerksCommentary = values.commentary.clerksCommentary;
    body.commentary = {
      postContent: values.commentary.postContent,
      clerksCommentary: clerksCommentary.trim() === "" ? null : clerksCommentary,
    };
  }
  const matters = Object.entries(dirty.matters ?? {})
    .filter(([, changed]) => changed)
    .map(([matterId]) => ({ matterId, summary: values.matters[matterId] ?? "" }));
  if (matters.length > 0) body.matters = matters;
  return body.commentary || body.matters ? body : null;
}
